import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import langpage from '@/components/langpage'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base:'/share/',  // 这是二级路径  
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/langpage',
      name: 'langpage',
      component: langpage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js